import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fileConstructionContent" }
const _hoisted_2 = { class: "fileConstructionContentCommonDirArea" }
const _hoisted_3 = { class: "fileConstructionContentFileArea" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "fileConstructionContentFileAreaLoadMore" }
const _hoisted_8 = { class: "fileConstructionContentFileAreaLoadMoreButton" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "dialog-footer" }

import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import {
    FileConstructionActions,
    FileConstructionGetters,
    FileConstructionMutations
} from "@/store/modules/fileConstruction";
import { useRoute } from "vue-router";
import { FileConstructionNode, FileDownloadStatus, DisplayTypeEnum } from "@/store/modules/fileConstruction/types";
import FileConstructionContentCommonDirList
    from "@/components/fileConstruction/fileConstructionContentCommonDirList.vue";
import changeToDateTime from '@/utils/timestamp2DateTime';
import { ElMessage, ElMessageBox } from 'element-plus'
import GetFileSize from "@/utils/fileSize";
import FileConstructionDigest from "@/components/fileConstruction/FileConstructionDigest.vue";

import { defineComponent } from 'vue';

const __default__ = defineComponent(
    {
        name: "FileConstructionContent"
    }
)

interface highlight {
    normal: string,
    light: string,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const store = useStore();
const route = useRoute();
const myTable = ref()
const dialogVisible = ref<boolean>(false)
const ossPictureViewer = ref<boolean>(false)
const dialogNode = ref<FileConstructionNode>()

const displaySrc = ref<string[]>([])
const inintialIndex = ref<number>(0)

const projectId = computed(() => typeof (route.params.projId) === "string" ?
    route.params.projId : route.params.projId[0]);
const targetId = computed(() => typeof (route.params.targetId) === "string" ?
    route.params.targetId : route.params.targetId[0]);
const displayType = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getIsSearching}`];
});
const isLoading = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getLoading}`];
});
const currentPath = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentPath}`];
});
const currentNode = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentFileConstructionNode}`];
});
const currentDigest = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentDigest}`];
})

watch(currentNode, (newValue: any, oldValue: any) => {
    myTable.value.store.clearSort()
});
const sortMethod = (column: any) => {
    let fieldName = column.prop;
    if (fieldName === 'info.size') {
        currentNode.value.children.map((item: any) => {
            item.info.size = item.info.size !== '' ? Number(item.info.size) : -1
        })
    }
}

const handleRowClick = (row: FileConstructionNode): void => {
    // TODO
    // Click on file should be emitted after file type added.
    if (isLoading.value) {
        return
    }
    if (displayType.value === DisplayTypeEnum.FileList) {
        if (row.file_type === 1) {
            return
        }
        const projId = projectId.value
        const pid = row.id;
        const uid = targetId.value;
        const filePath = currentPath.value + row.name + '/';
        try {
            store.commit(
                `fileConstruction/${FileConstructionMutations.pushBackHistory}`,
                currentPath.value,
            );
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetChildrenByPid}`,
                { projId, pid, uid, filePath },
            );
            store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
        } catch (err) {
            store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
            console.log(err)
        }
    } else if (displayType.value === DisplayTypeEnum.Searching || displayType.value == DisplayTypeEnum.Extension) {
        const projId = projectId.value
        const uid = targetId.value;

        asyncGetTargetPath(projId, uid, row)
    }
}

const asyncGetTargetPath = async (projId: string, uid: string, node: FileConstructionNode) => {
    // const targetPath = await fileConstructionAPI.getPathByNode({ projId: projId, nodeId: nodeId, uid: uid }) + '/'
    const targetPath = node.full_path.replaceAll("\\", "/")
    try {
        store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
        await store.dispatch(
            `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
            { projId: projId, filePath: targetPath, uid: uid, fileType: node.file_type },
        );
        store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
    } catch (err) {
        store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
        console.log(err)

    }
}

const loadMore = (): void => {
    if (!isLoading.value) {
        myTable.value.store.clearSort()
        const projId = projectId.value
        const pid = currentNode.value.id;
        const uid = targetId.value;
        if (displayType.value === DisplayTypeEnum.Searching) {
            const filename = currentPath.value.split('的搜索结果')[0]
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetSearchResult}`,
                { projId, uid, filename },
            );
        } else if (displayType.value === DisplayTypeEnum.Uploaded) {
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetUploadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: true },
            );
        } else if (displayType.value === DisplayTypeEnum.Downloaded) {
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetDownloadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: true },
            );
        } else if (displayType.value === DisplayTypeEnum.Extension) {
            const extension = currentPath.value.split('的匹配结果')[0]
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetExtensionFiles}`,
                { projId: projectId.value, uid: targetId.value, extension: extension, isAppend: true },
            );
        } else {
            const filePath = currentPath.value;
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetChildrenByPid}`,
                { projId, pid, uid, filePath },
            );
        }
    }
}

const handleGenerateLink = (node: FileConstructionNode) => {
    const projId = projectId.value
    const uid = targetId.value;
    const nodeId = node.id;
    store.dispatch(
        `fileConstruction/${FileConstructionActions.asyncGenDownloadLink}`,
        { projId, nodeId, uid },
    );
    ElMessage({
        message: '生成链接成功',
        type: 'success',
    })

}

// TODO beautify needed
const handleDownloadToggle = (node: FileConstructionNode) => {
    dialogVisible.value = true
    dialogNode.value = node
}

const displayPicture = (node: FileConstructionNode) => {
    ossPictureViewer.value = true
    let datas = currentNode.value.children
    displaySrc.value = []
    let index = 0
    let containSpecial = RegExp(
        /[(\#)(\$)(\%)(\&)(\+)(\/)(\\)(\=)(\?)(\:)(\ )]+/
    );
    datas.forEach((data: FileConstructionNode) => {
        if (data.download_status === FileDownloadStatus.UploadedToOss && data.ossLink !== '') {
            if (containSpecial.test(data.name)) {
                displaySrc.value.push(encodeURI(data.ossLink))
            } else {
                displaySrc.value.push(data.ossLink)
            }
            if (data.id === node.id) {
                inintialIndex.value = index
            }
            index = index + 1
        }
    })
}

const closeViewer = () => {
    ossPictureViewer.value = false
    displaySrc.value = []
}

const copyLink = (node: FileConstructionNode | undefined): void => {
    try {
        if (node === undefined) {
            return
        }
        let urlSlice = node.download_link.url.split('#!')
        if (urlSlice.length === 1) {
            ElMessage({
                message: '无效链接',
                type: 'error',
            })
        } else {
            copyText(`https://mega.nz/file/${urlSlice[urlSlice.length - 1]}#${node.download_link.pwd}`)
        }
    } catch (err) {
        console.log(err)
    }
}

const copyText = (data: string | undefined): void => {
    if (data === undefined) {
        return
    }
    let oInput = document.createElement('input');
    oInput.value = data;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    oInput.style.display = 'none';
    ElMessage({
        message: '复制成功',
        type: 'success',
    })
}

const highLight = (data: string): highlight[] => {
    const res = []
    const target: string = currentPath.value.split('的搜索结果')[0];

    const matchedArr = RegExp(target, 'i').exec(data);
    if (!matchedArr || matchedArr.length === 0) {
        res.push({ normal: data, light: '' })
        return res
    }
    const firstMatchedStr = matchedArr[0];
    const temp = data.split(firstMatchedStr)
    const len = temp.length
    for (let i = 0; i < len - 1; i++) {
        res.push({ normal: temp[i], light: firstMatchedStr })
    }
    res.push({ normal: temp[len - 1], light: '' })
    return res
}


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FileConstructionContentCommonDirList)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_el_table, {
          ref_key: "myTable",
          ref: myTable,
          data: _unref(currentNode).children,
          stripe: "",
          onRowClick: handleRowClick,
          "fixed-header": "",
          "max-height": "98%",
          style: {"overflow":"auto"},
          onSortChange: sortMethod
        }, {
          append: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              ((typeof _unref(currentDigest)) !== 'undefined')
                ? (_openBlock(), _createBlock(FileConstructionDigest, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                (!_unref(currentNode).isAllLoaded)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      link: "",
                      type: "primary",
                      disabled: _unref(isLoading),
                      onClick: loadMore
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 加载更多 ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "------已全部加载------"))
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "名称" }, {
              default: _withCtx((scope) => [
                (_unref(displayType) === _unref(DisplayTypeEnum).Searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highLight(scope.row.name), (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          _createTextVNode(_toDisplayString(item.normal), 1),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.light), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.name), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "info.size",
              label: "文件大小",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.info.size === -1 || scope.row.info.size === '0' || scope.row.info.size === '' ?
                            '' :
                            _unref(GetFileSize)(Number(scope.row.info.size))), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "info.date_created",
              label: "创建时间"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.info.date_created !== 0 ?
                            _unref(changeToDateTime)(scope.row.info.date_created).substring(0,
                                16) : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "info.date_modified",
              label: "修改时间",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.info.date_modified !== 0 ?
                            _unref(changeToDateTime)(scope.row.info.date_modified).substring(0, 16) : ''), 1)
              ]),
              _: 1
            }),
            (_unref(displayType) !== _unref(DisplayTypeEnum).FileList)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "info.full_path",
                  label: "路径",
                  width: "300px"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.full_path), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                (scope.row.download_status === _unref(FileDownloadStatus).Uploaded)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "success",
                      onClick: ($event: any) => (handleGenerateLink(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("生成链接")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.download_status === _unref(FileDownloadStatus).Downloaded)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      type: "success",
                      onClick: ($event: any) => (handleDownloadToggle(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下载")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (scope.row.download_status === _unref(FileDownloadStatus).Downloading)
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 2,
                        type: "primary",
                        disbaled: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("下载中...")
                        ]),
                        _: 1
                      }))
                    : (scope.row.download_status === _unref(FileDownloadStatus).Idle && scope.row.file_type === 1)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 3,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 未上传 ")
                          ]),
                          _: 1
                        }))
                      : (scope.row.download_status === _unref(FileDownloadStatus).UploadedToOss && scope.row.ossLink !== '')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 4,
                            onClick: _withModifiers(($event: any) => (displayPicture(scope.row)), ["stop"]),
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("预览")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])), [
        [_directive_loading, _unref(isLoading)]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (copyLink(dialogNode.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("一键复制")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          direction: "horizontal",
          column: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: "下载链接:",
              align: "center",
              width: "25%"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dialogNode.value?.download_link.url) + " ", 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText(dialogNode.value?.download_link.url)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "密码:",
              align: "center",
              width: "25%"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dialogNode.value?.download_link.pwd) + " ", 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copyText(dialogNode.value?.download_link.pwd)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (ossPictureViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          onClose: closeViewer,
          "url-list": displaySrc.value,
          "initial-index": inintialIndex.value
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})